class OpinionLab {
    constructor() {
        this.loadScript.bind(this);
    }

    checkState(cb, script) {
        const state = script.readyState;

        if (!state || (/complete/).test(state)) {
            return cb;
        }
        return function() {
            throw new Error('OpinionLab global object not present');
        };
    }

    loadScript(cb, source) {
        if (document.getElementById('opinionlab')) {
            return;
        }

        let script = document.createElement('script');
        let src = source || '//csvcus.homeaway.com/rsrcs/stab-feedback/1.2.2/javascripts/opinionlab/oo_engine.min.js';
        script.type = 'text/javascript';

        script.onload = this.checkState(cb, script);
        script.id = 'opinionlab';

        script.src = src;
        (document.body || document.head).appendChild(script);
        return script; // eslint-disable-line consistent-return
    }

    createLauncher(event) {
        const windowOOo = window.OOo;
        if (windowOOo) {
            let options = {};
            const ADL = window.analyticsdatalayer;

            if (ADL) {
                // It is necessary to encode ADL values
                // because the presence of commas will break
                // OL's parser resulting in loss of the ADL
                // custom variable
                options.customVariables =
                Object
                .keys(ADL)
                .reduce((encoded, key) => {
                    encoded[key] = encodeURIComponent(ADL[key]);
                    return encoded;
                }, {});
            }

            windowOOo.oo_feedback = new windowOOo.Ocode(options);
            windowOOo.oo_feedback.show(event);
        } else {
            throw new Error('OpinionLab global object not loaded');
        }
    }
}

export default OpinionLab;
